export default class NetworkError extends Error {
  constructor(public message: string) {
    super(message);
    this.name = 'NetworkError';
    // Set the prototype explicitly, see https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    // extending classes will also need to do this
    Object.setPrototypeOf(this, NetworkError.prototype);
  }
}
